import { useEffect } from 'react';
import { Button } from '../../components/button/button';
import { appVersionKey } from '../../helpers/local-storage';
import { appVersion, swPath } from '../../helpers/path';
import { useLang } from '../../hooks/use-lang';
import { useToggle } from '../../hooks/use-toggle';
import { useAlertStore } from '../../store/use-alert-store';

const defaultInitVersion = '2.15.5';

// При обновлении версии, обновляем приложение и service worker
export const useVersion = () => {
  const { add, reset } = useAlertStore();
  const { t } = useLang();
  const savedVersion = localStorage.getItem(appVersionKey) || defaultInitVersion;
  const [isLoading, toggleIsLoading] = useToggle();

  const handleRegisterServiceWorker = async () => {
    toggleIsLoading();

    try {
      const isExist = await navigator.serviceWorker.getRegistrations();
      if (isExist) isExist.forEach(async (reg) => await reg.unregister());
      await navigator.serviceWorker.register(swPath);
      window.location.reload();
    } catch (e) {
      console.error('Error registering service worker:', e);
    } finally {
      toggleIsLoading();
    }
  };

  const handleUpdateVersion = async () => {
    localStorage.setItem(appVersionKey, appVersion);
    reset();
    await handleRegisterServiceWorker();
  };

  useEffect(() => {
    if (appVersion !== savedVersion) {
      add({
        label: t('Доступна новая версия приложения'),
        variant: 'info',
        children: (
          <Button variant="info" onClick={handleUpdateVersion}>
            {t('Обновить')}
          </Button>
        ),
      });
    } else {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        if (!registrations.length) {
          handleRegisterServiceWorker();
        }
      });
    }
  }, []);

  return { savedVersion, isLoading };
};
